import { render, staticRenderFns } from "./TagsFilters.vue?vue&type=template&id=d33c045e"
import script from "./TagsFilters.vue?vue&type=script&lang=js"
export * from "./TagsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports